// Promotion keys for June 2025 New Customer Starter Promotion
// QA environment promotion keys
const JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_ANNUAL_QA = 'NEW_STARTER_MAY2025__ACAP';
const JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_MONTHLY_QA = 'MAY_25_NEW_CUSTOMER_STARTER_MCMP';

// Production environment promotion keys
const JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_ANNUAL_PROD = 'NEW_CUSTOMER_STARTER_PROMOTION_ANNUAL_DISCOUNT_55';
const JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_MONTHLY_PROD = 'NEW_CUSTOMER_STARTER_PROMOTION_MONTHLY_25';

// HC-0136: Trial Discount Promotion keys
export const HC_0136_SALES_HUB_PROFESSIONAL = 'SALES_HUB_PROFESSIONAL_TRIAL_DISCOUNT_20';
export const HC_0136_SERVICE_HUB_PROFESSIONAL = 'SERVICE_HUB_PROFESSIONAL_TRIAL_DISCOUNT_20';

/**
 * All promotion keys for the June 2025 New Customer Starter Promotion.
 * Includes both QA and production environment keys for annual and monthly terms.
 */
export const JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS = [JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_ANNUAL_QA, JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_MONTHLY_QA, JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_ANNUAL_PROD, JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_MONTHLY_PROD];
export const COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS = ['COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_2025_11_18_23_51_19',
//ACMP 40% QA
'COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_2025_11_18_22_28_45',
//ACMP 40% PROD
'COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_ANNUAL_PAYMENT_2025_11_18_23_47_37',
//ACAP 50% QA
'COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_ANNUAL_PAYMENT_2025_11_18_22_24_35',
//ACAP 50% PROD
'COMMERCE_HUB_ENTERPRISE_EARLY_ADOPTER_PROMOTION' //ACAP + ACMP 40% (QA & PROD)
];

/**
 * All promotion keys for the December 2025 New Customer Starter Promotion.
 * This promotion offers ACAP at $9/mo and MCMP at $10/mo.
 */
export const DECEMBER_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS = ['2025_NEW_CUSTOMER_STARTER_PROMOTION_MONTHLY_50', 'NEW_CUSTOMER_STARTER_PROMOTION_ANNUAL_DISCOUNT_55'];